import { module } from 'angular';

import { HEALTH_COUNTS_COMPONENT } from './healthCounts.component';

export const HEALTH_COUNTS_MODULE = 'spinnaker.core.healthCounts';
module(HEALTH_COUNTS_MODULE, [
  HEALTH_COUNTS_COMPONENT,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/healthCounts/healthCounts.module.ts